import { object, string } from 'yup';
import { CreateCommand } from '../../entity/RealtimeEvent.js';
import { RealtimeEventType } from '../../enums.js';

const SCHEMA = object({
  id: string().required(),
  comment_id: string().required(),
  new_content: string().required(),
  edited_at: string()
    .datetime({
      allowOffset: true,
    })
    .required(),
});

/**
 * CardCommentUpdateEvent
 *
 * - Evento emitido quando um comentário de card é editado.
 */
export class CardCommentUpdateEvent extends CreateCommand(RealtimeEventType.CardCommentUpdate, SCHEMA) {}
